/* globals PushNotification: true */

import navigateTo from '../app/navigate_to';
import rollbar    from '../rollbar';

let push = null;

export function enableNotifications({ onToken, onNotification, onDataMessage }) {
  if (!push)
    push = init();

  push.on('notification', function({ title, message, additionalData }) {
    // Through FCM we send title + body, Firebase receives it as such, but
    // phonegap-plugin-push receives it as title + message.
    if (title && message) {
      const url = additionalData.url || additionalData.category;

      if (additionalData.foreground) {
        // App is in foreground. Let's show in-app notification.
        onNotification({ title, body: message, url });
      } else if (url) {
        // App was in background, but push notification was clicked.
        // Let's not display in-app notification, but honor clicked URL.
        navigateTo(url);
      }
    }

    if (additionalData.action)
      onDataMessage(additionalData);
  });

  // Initialize once per application, but we lose all event handlers if we
  // previously called unregister
  push.on('registration', function(data) {
    const deviceToken = data.registrationId;
    onToken(deviceToken);
  });

  push.on('error', function(error) {
    rollbar.error(error);
  });
}


export async function disableNotifications() {
  if (push) {
    await new Promise(function(resolve, reject) {
      push.unregister(resolve, reject);
    });
  }
}


export async function getNotificationState() {
  return new Promise(resolve => {
    PushNotification.hasPermission(data => {
      if (data.isEnabled)
        resolve('granted');
      else
        resolve('default'); // if false, assume we haven't asked
    });
  });
}


export function setBadgeCount({ number }) {
  if (push) {
    push.setApplicationIconBadgeNumber(
      () => {},
      () => {},
      number
    );
  }
}


function init() {
  return PushNotification.init({
    android: {
      clearNotifications: true,
      sound:              true,
      vibrate:            true
    },
    ios: {
      alert: true,
      badge: true,
      sound: true
    }
  });
}
